import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { viewersOvbFeatureSelector, ovbViewersMetricsEnabledSelector } from '@store/common/selectors';
import ViewToggle from './ViewToggle';
import { DimensionWidgetWrapper } from './styled';
import DimensionTable from './DimensionTable';
import ViewersTable from './viewerSessions';
import { Tabs } from './utils';

function DimensionContainer({ config, widgetIndex }) {
  const [tab, setTab] = useState(Tabs.Trends);

  const viewersOvbEnabled = useSelector(viewersOvbFeatureSelector);
  const showViewersTab = useSelector(ovbViewersMetricsEnabledSelector);

  return (
    <DimensionWidgetWrapper>
      {viewersOvbEnabled && showViewersTab && <ViewToggle selectedTab={tab} setTab={setTab} />}
      <DimensionTable show={tab === Tabs.Trends} config={config} widgetIndex={widgetIndex} />
      {tab === Tabs.Viewers && <ViewersTable />}
    </DimensionWidgetWrapper>
  );
}

export default DimensionContainer;
